module.exports = __webpack_public_path__ + "static/media/loader_goodie.6246b3db.gif";